var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"icon":"fad fa-piggy-bank","title":"Slevy"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('PrimaryLinkButton',{attrs:{"to":"/discounts/create","icon":"fad fa-plus-circle","text":"Vytvořit slevu"}})]},proxy:true}])}),_c('DiscountsGrid',{staticClass:"mb-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }